import type { ReactNode } from 'react'
import { cn } from '@/lib/cn'

interface Item {
  id: string
  label: ReactNode
  badge?: ReactNode
}

interface Props {
  items: Item[]
  active: string
  onChange: (id: string) => void
}

export function Tabs({ items, active, onChange }: Props) {
  return (
    <div className="border-b border-gray-200 mb-4">
      <nav className="flex gap-1">
        {items.map((it) => {
          const isActive = it.id === active
          return (
            <button
              key={it.id}
              type="button"
              onClick={() => onChange(it.id)}
              className={cn(
                'cursor-pointer px-3 py-2 text-sm border-b-2 transition flex items-center gap-2',
                isActive
                  ? 'border-brand-500 text-brand-700 font-medium'
                  : 'border-transparent text-gray-500 hover:text-gray-700',
              )}
            >
              {it.label}
              {it.badge}
            </button>
          )
        })}
      </nav>
    </div>
  )
}
